import './reducers/tab.reducer';
import './reducers/toasts.reducer';

export {default as appActions, TYPES as AppTypes} from './actions/app.actions';
export {default as tabActions, TYPES as TabTypes} from './actions/tab.actions';
export {default as toastActions, TYPES as ToastTypes} from './actions/toast.actions';

// selectors
import * as app from './selectors/app.selectors';
import * as localization from './selectors/localization.selectors';
import * as router from './selectors/router.selectors';

// exports
export const appSelectors = app;
export const localizationSelectors = localization;
export const routerSelectors = router;
